import { CatalogueItemStatus, CatalogueItemType } from '../types';
import { CatalogueItemDetailsDto } from './catalogue-item-details.dto';

export class CatalogueItemDetails {
    id: string | null;
    image: string | null;
    publishDate: Date | null;
    type: CatalogueItemType | null;
    name: string;
    artists: string;
    status: CatalogueItemStatus | null;

    constructor(dto: CatalogueItemDetailsDto) {
        this.id = dto.id ?? null;
        this.image = dto.image ?? null;
        this.publishDate = dto.publish_ts ? new Date(dto.publish_ts * 1000) : null;
        this.type = dto.type ?? null;
        this.name = dto.name ?? '';
        this.artists = dto.artists?.join(', ') ?? '';
        this.status = dto.status ?? null;
    }
}
